import { render, staticRenderFns } from "./WebSearchPEPConfigurations.vue?vue&type=template&id=6644973b&"
import script from "./WebSearchPEPConfigurations.vue?vue&type=script&lang=js&"
export * from "./WebSearchPEPConfigurations.vue?vue&type=script&lang=js&"
import style0 from "./WebSearchPEPConfigurations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports